.bar {
  margin: 0 0 12px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
}

/* The table page's filter line (ADR-0212): the search first, at a fixed width (it used to take whatever
   was left, so it measured anywhere from 155 to 1091px between pages), then the filters, then the count
   and the view controls at the right end. It is one row where it fits, and where it does not (1024px, or a
   long run of filter chips) the right-hand group drops to a second row inside the card - it wraps rather
   than overflowing the card (U6, 2026-11-03: Documents and Processing, Missing ran past the card edge). */
.barOne {
  margin: 0;
}

.rowOne {
  flex-wrap: wrap;
  row-gap: 8px;
}

/* The right-hand group is one line in itself: left to wrap it stacked the count, "About these
   categories" and "Methodologies" in a column of three different widths (alignment audit, 2026-11-03).
   It sits at the right edge whichever row it lands on. */
.rowOne .end {
  flex: 0 0 auto;
  flex-wrap: nowrap;
  margin-left: auto;
  white-space: nowrap;
}

.rowOne .search {
  flex: 0 0 280px;
  width: 280px;
  min-width: 0;
}

@media (max-width: 1100px) {
  .rowOne .search {
    flex-basis: 240px;
    width: 240px;
  }
}

@media (max-width: 900px) {
  .rowOne .search {
    flex: 1 1 100%;
    width: auto;
  }

  .rowOne .end {
    flex-wrap: wrap;
  }
}

/* A native select with our chevron: the platform's arrow is removed (appearance: none). */
.selectWrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}

.select {
  appearance: none;
  height: var(--h-ctl);
  max-width: 200px;
  padding: 0 28px 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-dense);
  text-overflow: ellipsis;
  cursor: pointer;
  transition:
    border-color var(--dur-1) var(--ease-std),
    background var(--dur-1) var(--ease-std);
}

.select:hover {
  border-color: var(--accent-line);
}

.select:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.selectOn .select {
  border-color: var(--accent-line);
  background: var(--accent-w);
  color: var(--accent);
  font-weight: 650;
}

.selectCaret {
  position: absolute;
  right: 10px;
  color: var(--muted);
  pointer-events: none;
}

.saved {
  display: flex;
  align-items: center;
}

.search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 260px;
  min-width: 160px;
}

.searchIcon {
  position: absolute;
  left: 10px;
  color: var(--muted);
  pointer-events: none;
}

.search input {
  width: 100%;
  height: var(--h-ctl);
  padding: 0 10px 0 32px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
}

.search input::placeholder {
  color: var(--muted);
}

.search input:hover {
  border-color: var(--accent-line);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.funnel {
  color: var(--muted);
}

.chipWrap {
  position: relative;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font-size: var(--t-dense);
  cursor: pointer;
  transition:
    border-color var(--dur-1) var(--ease-std),
    background var(--dur-1) var(--ease-std);
}

.chip:hover {
  border-color: var(--accent-line);
}

.chipOn {
  border-color: var(--accent-line);
  background: var(--accent-w);
  color: var(--accent);
  font-weight: 650;
}

.badge {
  min-width: 18px;
  padding: 0 5px;
  border-radius: var(--radius-pill);
  background: var(--accent);
  color: var(--on-fill);
  font-size: var(--t-min);
  line-height: 18px;
  text-align: center;
}

.list {
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  left: 0;
  min-width: 200px;
  max-width: min(320px, 90vw);
  max-height: 320px;
  padding: 4px;
  overflow-y: auto;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-card);
  background: var(--panel);
  box-shadow: var(--shadow-pop);
}

/* A long option list: the search box stays at the top and the options scroll beneath it. */
.listWithSearch {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.listScroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.listSearch {
  flex: none;
  box-sizing: border-box;
  width: 100%;
  min-height: var(--target-min);
  margin-bottom: 4px;
  padding: 0 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
}

.listSearch:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.listEmpty {
  padding: 8px;
  color: var(--muted);
  font-size: var(--t-dense);
}

.option {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 5px 8px;
  border-radius: var(--radius-ctl);
  color: var(--ink);
  font-size: var(--t-dense);
  cursor: pointer;
}

.option:hover {
  background: var(--panel-2);
}

.option:focus-visible {
  background: var(--accent-w);
  outline-offset: -2px;
}

.option[aria-selected="true"] {
  font-weight: 650;
}

.tick {
  display: grid;
  flex: 0 0 14px;
  place-items: center;
  color: var(--accent);
}

.optionLabel {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.optionCount {
  color: var(--muted);
  font-size: var(--t-min);
  font-variant-numeric: lining-nums tabular-nums;
}

.clear {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: var(--h-ctl);
  padding: 0 8px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: var(--accent);
  font-size: var(--t-dense);
  font-weight: 650;
  cursor: pointer;
}

.clear:hover {
  background: var(--accent-w);
}

.end {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px 12px;
}

.count {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
  font-variant-numeric: lining-nums tabular-nums;
}

.views {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 10px;
  border-right: 1px solid var(--line-2);
}

.view,
.save {
  height: var(--h-ctl);
  padding: 0 11px;
  border: 1px solid transparent;
  border-radius: var(--radius-pill);
  background: none;
  color: var(--ink-2);
  font-size: var(--t-dense);
  cursor: pointer;
}

.view:hover,
.save:hover {
  background: var(--panel-3);
}

.viewOn {
  border-color: var(--accent-line);
  background: var(--accent-w);
  color: var(--accent);
  font-weight: 650;
}

.save {
  color: var(--accent);
  font-weight: 650;
}

@media (width <= 900px) {
  .chip,
  .clear,
  .view,
  .save,
  .search input {
    height: var(--target-touch);
  }

  .option {
    min-height: var(--target-touch);
  }

  .search {
    flex: 1 1 100%;
  }

  .end {
    justify-content: flex-start;
  }
}
